<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <Select key="4" :selected.sync="listQuery.shop_id" :data="selectList" clearable placeholder="请选择店铺" />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-date-picker
              v-model="listQuery.begin_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            />
            <i class="split-time">至</i>
            <el-date-picker
              v-model="listQuery.end_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetOrderList">查询</el-button>
            <span style="color:#409EFF;font-size: 16px;margin-left:20px">总计：111人</span>
          </el-form-item>

        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="店铺" prop="name" align="center" />
        <el-table-column label="订餐份数" prop="sell_day" align="center" />
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="listQuery.p"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          :page-size="listQuery.limit"
          @current-change="fnGetOrderList"
        >
          <div class="chax">
            {{ listQuery.p }}/{{
              total > 0 ? Math.ceil(total / listQuery.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ total }}条</i>
          </span>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import Select from '@/components/Select'
var moment = require('moment')

export default {
  name: 'ShopMenuOrderList',
  components: {
    Select

  },
  data() {
    return {
      selectList: [],
      lists: [],
      tableKey: 0,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20,
        child_id: '',
        shop_id: '',
        begin_time: moment().format('YYYY-MM-DD'),
        end_time: moment().format('YYYY-MM-DD')
      }
    }
  },
  created() {
    this.fnGetSelectList()
    this.fnGetOrderList()
  },
  methods: {
    fnGetOrderList: function() {
      this.$http.orderFoodStatistics(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data.list
        this.total = parseInt(res.data.count)
      })
    },
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.selectList = res.data
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
